import { useTranslate } from '../../lib'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ButtonYesNo from '../common/ButtonYesNo'

export default function WizardStep7({ 
  formData, 
  setFormData, 
  refs
}) {
  const { t } = useTranslate();

  return (
    <div className="wizard-step">
      <h2 className="mb-4" style={{ color: '#0B5FA3', fontSize: 20 }}>
        {t('menu.genai.simulationSettings')}
      </h2>

      <div className="p-0-mb flex flex-col flex-1 mt-2" style={{ paddingRight: 20, paddingLeft: 20 }}>
        <div className="d-flex flex-row flex-wrap w-100">
          <div className='d-flex flex-row mt-3 mb-3' style={{ alignItems: 'center', width: '100%' }}>
            <h2 className="" style={{ color: '#1C6FB0', fontSize: 16, fontWeight: 'bold' }}>
              {t('menu.genai.simulationStatus')}:
            </h2>
            <div style={{ marginLeft: 20 }}>
              <ButtonYesNo
                onClick={() => {
                  const newStatus = formData.simulationStatus === 0 ? 1 : 0;
                  setFormData({
                    ...formData,
                    simulationStatus: newStatus,
                    assistedSimulation: newStatus === 0 ? 0 : formData.assistedSimulation
                  });
                }}
                width={150}
                state={formData.simulationStatus === 0 ? false : formData.simulationStatus}
                height={30}
                Yes={t('common.yes')}
                No={t('common.no')}
              />
            </div>
          </div>

          <div className="inputs w-100 pr-2 mb-5 mt-2">
            <div className="input d-flex" style={{ alignItems: 'center', flexDirection: 'row' }}>
              <span>{t('menu.genai.urlSimulation')}:</span>
              <input
                className='input-data'
                placeholder={t('menu.genai.urlSimulationPlaceholder')}
                disabled={!formData.simulationStatus}
                ref={refs.url_tp_simulation_ref}
                type="text"
                onChange={(e) => setFormData({ ...formData, url_simulation: e.target.value })} 
                defaultValue={formData.url_simulation}
              />
            </div>
          </div>

          <div className="inputs mt-1" style={{ marginRight: 30 }}>
            <div className="input d-flex items-center" style={{ height: "auto", flexDirection: 'row' }}>
              <span>{t('menu.genai.simulationStepNumber')}:</span>
              <img id="simulation-steps" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" alt="" />
              <Tooltip openOnClick={true} anchorSelect="#simulation-steps"
                html={t('menu.genai.simulationStepNumberTooltip')} place="top" />
              <input
                disabled={!formData.simulationStatus}
                ref={refs.Simulation_Step_number_ref}
                id="Simulation_Step_number_ref"
                style={{ maxWidth: 90 }}
                type="text"
                className={`input-text input-data ${!formData.simulationStatus ? 'disabled' : ''}`}
                onChange={(e) => setFormData({ ...formData, steps_simulation: e.target.value })} 
                defaultValue={formData.steps_simulation}
              />
            </div>
          </div>

          <div className="inputs mt-1" style={{ marginRight: 30 }}>
            <div className="input d-flex align-items-center" style={{ flexDirection: 'row' }}>
              <span>{t('menu.genai.assistedSimulation')}:</span>
              <img id="assisted-simulation" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" alt="" />
              <Tooltip openOnClick={true} anchorSelect="#assisted-simulation"
                html={t('menu.genai.assistedSimulationTooltip')} place="top" />
              <div className="list_bot_type d-flex flex-row align-items-center">
                <ButtonYesNo
                  onClick={() => setFormData({ ...formData, assistedSimulation: formData.assistedSimulation === 0 ? 1 : 0 })}
                  width={150}
                  state={formData.assistedSimulation}
                  height={30}
                  Yes={t('common.yes')}
                  No={t('common.no')}
                  disabled={!formData.simulationStatus}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
